var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueModal',_vm._b({attrs:{"name":_vm.name,"width":"90%","height":"auto","maxWidth":750,"classes":['v--modal', 'recyco-modal']}},'VueModal',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }